import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  orderLoadRequest: null,
  orderReloadRequest: null,
  orderLoaded: ['payload'],
}, { prefix: '[ORDER] ' });
